import type { SerializedConstructor } from '@langchain/core/load/serializable';

import type { ManifestPreviewProps } from '../../../Manifest.utils';
import { manifestModelAndProvider } from '../../ManifestConstructor';

export function useRunnableBindingModelAndProvider(
  props: ManifestPreviewProps<SerializedConstructor>
): { model: string | null; provider: string | null } | null {
  return manifestModelAndProvider({
    value: props.value.kwargs.bound,
    options: props.options,
    variant: props.variant,
  });
}
